module.exports = __webpack_public_path__ + "media/images/emoticons/ban-b6add1b2629e60c919229eb9e4e44f75.gif";